import React from "react";
import Slider from "../../../components/Slider";
import { useDispatch, useSelector } from "react-redux";
import TooltipPrimary from "../../../components/tooltips/TooltipPrimary";
import SyncRoundedIcon from "@mui/icons-material/SyncRounded";
import ShuffleRoundedIcon from "@mui/icons-material/ShuffleRounded";
import SkipPreviousRoundedIcon from "@mui/icons-material/SkipPreviousRounded";
import SkipNextRoundedIcon from "@mui/icons-material/SkipNextRounded";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import PauseRoundedIcon from "@mui/icons-material/PauseRounded";
import HourglassBottomRoundedIcon from "@mui/icons-material/HourglassBottomRounded";
import VolumeUpRoundedIcon from "@mui/icons-material/VolumeUpRounded";
import VolumeOffRoundedIcon from "@mui/icons-material/VolumeOffRounded";
import PlaylistAddRoundedIcon from "@mui/icons-material/PlaylistAddRounded";
import { setselectedAddPlaylist } from "../../../redux/actions/music";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";

const MusicPlayer = (props) => {
  const dispatch = useDispatch();
  const {
    playSong,
    pauseSong,
    onChangeRange,
    toggleVolume,
    musicPlayerRef,
    hideActions,
    onClickPrev,
    onClickNext,
    fullScreen,
    enterFullScreen,
    exitFullScreen,
    expandScreen,
    enterExpandScreen,
    exitExpandScreen,
  } = props;

  const {
    currentSong,
    currentSong: { name, artist, img },
    maxRange,
    range,
    play,
    loaded,
    onChangeLoaded,
    volume,
  } = useSelector((state) => state.player);

  function minCalc(value) {
    const min = Math.floor(value / 60);
    let sec = value % 60;
    sec = sec <= 9 ? `0${sec}` : sec;
    return `${isNaN(min) ? "00" : min}:${isNaN(sec) ? "00" : sec}`;
  }

  return (
    <div className={`music-player-snap ${hideActions ? "hide-actions" : ""}`} ref={musicPlayerRef}>
      <TooltipPrimary className="left-icon" text="Back" onClick={onClickPrev}>
        <SkipPreviousRoundedIcon />
      </TooltipPrimary>
      <TooltipPrimary className="right-icon" text="Forward" onClick={onClickNext}>
        <SkipNextRoundedIcon />
      </TooltipPrimary>
      <div className="header">
        <h3>Snap</h3>
        <div className="header-actions">
          <TooltipPrimary className="icon" text="Volume" onClick={toggleVolume}>
            {volume ? <VolumeUpRoundedIcon /> : <VolumeOffRoundedIcon />}
          </TooltipPrimary>
          <TooltipPrimary
            className="icon"
            text="Add to playlist"
            onClick={() => dispatch(setselectedAddPlaylist(currentSong))}
          >
            <PlaylistAddRoundedIcon />
          </TooltipPrimary>
          {!fullScreen && (
            <TooltipPrimary
              className="icon hd-tbmb"
              text={expandScreen ? "Collapse screen" : "Expand screen"}
              onClick={() => (expandScreen ? exitExpandScreen() : enterExpandScreen())}
            >
              {expandScreen ? <CloseFullscreenIcon /> : <OpenInFullIcon />}
            </TooltipPrimary>
          )}
          <TooltipPrimary
            className="icon"
            text={fullScreen ? "Exit full screen" : "Full screen"}
            onClick={() => (fullScreen ? exitFullScreen() : enterFullScreen())}
          >
            {fullScreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
          </TooltipPrimary>
        </div>
      </div>
      <div className="player">
        <div className="details">
          <img src={img} alt="black pink" />
          <div className="desc">
            <h1>{name}</h1>
            <h3>{artist}</h3>
            <p className="album">Album</p>
          </div>
        </div>
        <div className="actions-cont">
          <div className="actions">
            <div className="buttons">
              {!loaded || !onChangeLoaded ? (
                <div className="icon spinner">
                  <HourglassBottomRoundedIcon />
                </div>
              ) : play ? (
                <TooltipPrimary className="icon pause-btn" text="Pause" onClick={pauseSong}>
                  <PauseRoundedIcon />
                </TooltipPrimary>
              ) : (
                <TooltipPrimary className="icon play-btn" text="Play" onClick={playSong}>
                  <PlayArrowRoundedIcon />
                </TooltipPrimary>
              )}
            </div>
          </div>
          <div className="range">
            <div className="timer">
              <p>{minCalc(range)}</p>
              <p>{minCalc(maxRange)}</p>
            </div>
            <Slider min={0} max={maxRange} value={range} onChange={onChangeRange} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MusicPlayer;
